import styled from 'styled-components';
import { white } from 'styles/Colors';

export const EndOfTaggingFlowCardWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 51px;
  background: linear-gradient(342.04deg, #00b400 10.06%, #009900 93.1%);
  border-radius: 5px;
  margin-top: auto;
`;

export const TitleAndSubtitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: Lato;
  font-size: 15px;
  letter-spacing: 0.5px;
  color: ${white};
`;
export const Title = styled.div`
  font-weight: bold;
`;
